import * as React from 'react';
import { NavLink } from 'react-router-dom';

import { LogoGoldman } from '../logos/logo-goldman';
import { IBaseProps } from '../../types';
import * as styles from './header.css';

interface ILink {
  url: string;
  title: string;
}

export const links: ILink[] = [
  { url: '/welcome', title: 'Home' },
  { url: '/careers', title: 'Careers' }
];

interface IHeaderProps extends IBaseProps {
  fillBackground?: boolean;
  push: (url: string) => void;
}

interface IHeaderState {
  width: number;
}

export class Header extends React.Component<IHeaderProps, IHeaderState> {
  constructor(props) {
    super(props);

    this.state = {
      width: document.documentElement!.clientWidth
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  private handleResize = (): void =>
    this.setState({
      width: document.documentElement!.clientWidth
    });

  private renderLogo = (): JSX.Element => {
    return (
      <a href="/welcome">
        <LogoGoldman className={styles.gsLogo} color="#ffffff" />
      </a>
    );
  };

  render() {
    const {
      match: { url }
    } = this.props;

    return (
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.logo}>{this.renderLogo()}</div>
          <div>
            <ul>
              {links.map((l, idx) => {
                const isActive = () => url.includes(l.url);

                return (
                  <li key={idx}>
                    <NavLink to={l.url} isActive={isActive} activeClassName={styles.active}>
                      {l.title}
                    </NavLink>
                  </li>
                );
              })}
              <li style={{ paddingLeft: '30px' }}>
                <a href="/s">Login</a> {/* we point to /s so that router can handle redirect */}
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
